/**
 * Reddit Conversion Configuration
 * 
 * This file contains the conversion IDs for Reddit tracking.
 * Update these IDs with the actual conversion IDs from your Reddit Ads Manager.
 */

export const REDDIT_CONVERSION_IDS = {
  // Registration conversion ID - replace with your actual ID from Reddit Ads Manager
  REGISTRATION: import.meta.env.VITE_REDDIT_REGISTRATION_CONVERSION_ID || 'REGISTRATION_CONVERSION_ID',
  
  // RFP creation conversion ID - replace with your actual ID from Reddit Ads Manager
  RFP_CREATION: import.meta.env.VITE_REDDIT_RFP_CONVERSION_ID || 'RFP_CREATION_CONVERSION_ID',
  
  // Subscription conversion ID - replace with your actual ID from Reddit Ads Manager
  SUBSCRIPTION: import.meta.env.VITE_REDDIT_SUBSCRIPTION_CONVERSION_ID || 'SUBSCRIPTION_CONVERSION_ID',
  
  // Contact form conversion ID - replace with your actual ID from Reddit Ads Manager
  CONTACT_FORM: import.meta.env.VITE_REDDIT_CONTACT_CONVERSION_ID || 'CONTACT_FORM_CONVERSION_ID',
  
  // Page view conversion ID - replace with your actual ID from Reddit Ads Manager
  PAGE_VIEW: import.meta.env.VITE_REDDIT_PAGE_VIEW_CONVERSION_ID || 'PAGE_VIEW_CONVERSION_ID'
}

/**
 * Reddit Pixel Configuration
 */
export const REDDIT_PIXEL_CONFIG = {
  PIXEL_ID: 't2_74n8n',
  
  // Default conversion values
  DEFAULT_VALUES: {
    REGISTRATION: 50,
    RFP_CREATION: 100,
    SUBSCRIPTION: 299,
    CONTACT_FORM: 25,
    PAGE_VIEW: 5
  },
  
  // Default currency
  DEFAULT_CURRENCY: 'USD'
}
